(function(){
'use strict';

frsLandingCtrl.$inject = ["$scope"];
function frsLandingCtrl($scope) {
  $scope.page = $scope.theme.pages.landing;
}

angular.module('classy.frs').controller('frs-landingCtrl', frsLandingCtrl);
})();